import deburr from 'lodash/deburr';

const sanitizeStringForUrl = (brand = '')=>deburr(brand// replace unwanted characters with a space
    .replace(/['"`´‘’!.&_\-\+]+/gi, ' ').trim().toLowerCase()// replace all consecutive whitespace characters with a dash
    .replace(/\s+/gi, '-'))
;

export { sanitizeStringForUrl };
//# sourceMappingURL=sanitize-string-for-url.js.map
